import ChatError from '../components/chat/ChatError';
import ChatContainer from '../containers/chat/ChatContainer';

export default function ChatPage() {
    return (
        <ChatContainer />
        // <ChatError />
    );
}
